module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked@2x.98e95460.png";